import React , {useState, useEffect} from 'react'
import NewsItem from './NewsItem'
import { GetAllNews } from './API';

export default function NewsList(props) {
    const [data, setData] = useState([])
    useEffect(() => {
         GetAllNews(props.Lang=='ar' ? 1:2).then(data => {
            setData( data );
            window.$('.newsCardTitle').succinct({
                    size: 250
                });
        });
    }, [props.Lang])
    return (
        <div class="row">
            {data.map( item => <NewsItem Lang={props.Lang} key={item.event_id} {...item} /> )}
            
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/pages/News/NewsList.js